<template lang="pug">
      .row.portfolio-row
        router-view(:visible="true", @hide="hideModal")
          .project-modal
            h2.subject 
              b Subject: 
              | {{routeProject.title}}
            p.desc 
              b Description: 
              | {{routeProject.description}}
            p.link 
              b Link:
              a(:href=`routeProject.link || 'javascript:void(0)'`, target='_blank') {{routeProject.link || 'unavailiable'}}
            .tech-area
              h3.tech-title 
                b Technologies Used:
              ul.tech-list
                li(v-for="str in routeProject.stack") {{str}}
            .image-area
              h3.image-title Image:
              img(:src="routeProject.image").image
        .col-xs-12.nav-row
          nav
            router-link(:to="{name:'home'}").nav-brand
              | McCall Alexander
        .col-xs-12.header-col
          h1 Portfolio
        .col-xs-12.search-bg
            multiselect(
              v-model="query", 
              :options="selectOptions", 
              key="909090909",
              :multiple="true",
              :close-on-select="true",
              :clear-on-select="true",
              :hide-selected="true",
              placeholder="Search something!☟",
              :show-labels="false"
              ).multiselect
            
            //- .multiselect(
            //-   v-model="query", 
            //-   :options="selectOptions", 
            //-   key="909090909",
            //-   :multiple="true",
            //-   :close-on-select="true",
            //-   :clear-on-select="true",
            //-   :hide-selected="true",
            //-   placeholder="Search something!☟",
            //-   :show-labels="false"
            //- )
        .col-xs-12.projects-bg
          .row
            .projects.col-xs-10.col-xs-offset-1
              transition-group(name="fade" appear).projects-list
                .project-item(
                  v-for="(project, index) in projects",
                  :key="index"
                )
                  project(
                    :key="index", 
                    :index="index", 
                    :project="project",
                  )
</template>

<script>
  import { SweetModal, SweetModalTab } from 'sweet-modal-vue/dist/sweet-modal.js'
  import Multiselect from 'vue-multiselect'
  import Project from './Project'
  import Modal from './Modal'
  import projects from './projects'
  import Sine from './Sine'
  import isMobile from 'ismobilejs'

  import Fuse from 'fuse.js'


  export default {
    name: 'portfolio',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        scrollOrigin:0,
        modalVisible:false,
        projectList:projects,
        query:[]
      }
    },
    computed:{
      routeProject(){
        let routeProj = this.projectList.find (
          (project)=>{
            return project.title == this.$route.params.name
          }
        )

        return routeProj || projects[0];
      },
      projects(){
        let options = {
          keys:['stack']
        }
        let results = this.projectList;
        this.query.forEach(
          str=>{
            let fuse = new Fuse(results, options);
            results = fuse.search(str)
          }
        )
        return results.sort((a,b)=>{
          return a.weight - b.weight
        }, {weight:0})
       
      },
      isMobile(){
        return isMobile.any
      },
      selectOptions(){
        let fullStack = new Set();
        this.projects.forEach((project)=>{
          project.stack.forEach(item=>{
            fullStack.add(item)
          })
        });
        return [...fullStack]
      },
    },
    components:{
      Project,
      Sine,
      Modal,
      Multiselect,
      SweetModal,
		  SweetModalTab,
    },
    methods:{
      handleScroll(){
        let winHeight = window.innerHeight
        let centerScrollPos = window.scrollY - winHeight/2
        this.scrollOrigin = centerScrollPos
      },
      showModal(){
        this.modalVisible = true;
      },
      hideModal(){
        this.$router.push({name:'portfolio'})
      }
    },
    mounted(){
      console.log(projects)
      let vm = this;
      let ecount = 0;
      // window.addEventListener('scroll', this.handleScroll);
      // this.handleScroll()
    },
    beforeDestroy () {
      let a = 0
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../assets/css/media-queries';
  @import '../assets/css/variables';
// *{
//   all:unset !important;
// }

  $color-main:black;
  $bg-main:white;


  .project-modal{
    position:absolute;
    top:0;bottom:0;left:0;right:0;
    overflow-wrap:break-word;
    overflow-x:hidden;
    overflow-y:scroll;
    padding:1rem 2rem;

    font-size:1.1rem;
    @include mobile {
      font-size:1.5rem;
    }

    .subject{
      font-size: 1.6em;
      font-weight: normal;
    }
    .desc, .link {
      font-size:1.2em;
    }

    .half{
      width:50%;
      @include mobile {
        width:100%;
      }
    }

    .tech-area{
      @extend .half;
      float:left;
      .tech-title{
        font-size: 1.2em;
      }
      .tech-list{
        font-size:1em;
        li{
          font-size:1em;
        }
      }
    }
    .image-area{
      @extend .half;
      float:left;
      .image-title{
        font-size: 1.2em;
      }
      .image{
        // filter:grayscale(50%);
        border:2px dashed black;
        padding:0.2rem;
        height:10em;
      }
    }
  }



  .wild{
    $grad-color:rgba(black, 0.2);
    background-image:url(../assets/waterfall.jpg), linear-gradient(to right, $grad-color, $grad-color);
    background-blend-mode:soft-light;
    background-size: cover;
    // background-attachment: fixed;
  }
  .portfolio-row{
    font-family: 'Cutive Mono', monospace;
    @extend .wild;

    // mix-blend-mode: screen;
    // // font-family: 'La Belle Aurore', cursive;
    color:$color-main;
    // mix-blend-mode: screen;

    .nav-row{
      background-color:$bg-main;
    }

    nav{
      margin:1rem;
      .nav-brand{
        font-size:3rem;
        font-family: 'La Belle Aurore', cursive;
        color:$color-main;
        height:10rem;
      }
    }

    .header-col{
      background-color:$bg-main;
      text-align: center;
      mix-blend-mode: screen;

      padding-top:2rem;
      margin-top:-2rem;
      h1{
        font-size:10rem;
        font-family: 'La Belle Aurore', cursive;
        margin:0;
      }
    }
  }

  $ms:'multiselect';
  .__#{$ms}__EL{
    background: white;
    color:black;
    border:2px solid black;
    border-radius: 2px;
  }
  .#{$ms}{
    // display: flex;
    // flex-direction: column;
    // border:2px solid black;
    // box-shadow: 0px 4px 15px rgba(black, 0.4);
    width: 40%;
    @include mobile{
      width:90%;
      margin: 0 5%;
    }
    margin-top:2rem;
    padding:5px;
    // border: {
    //   width:4px;
    //   style:solid;
    //   left: {
    //     color:$color-1;
    //   }
    //   right:{
    //     color:$color-2;
    //   }
    //   top:{
    //     color:$color-3;
    //   }
    //   bottom:{
    //     color:$color-4;
    //   }
    // }
    &__tags{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap:wrap;

      .#{$ms}__tag{
        @extend .__#{$ms}__EL;
        padding:5px;
        margin:3px;
        width: auto;
        font-size: 1.5rem;

        @include mobile {
          font-size:1.75rem;
        }

        &-icon{
          &:hover{
            cursor: pointer;
          }
          &:after{
            content:'x';
          }
        }
      }

      .#{$ms}__input{
        font-size: 2.5rem;
        width:100%;
        border:none;
        font-family: 'La Belle Aurore', cursive;
        // background:black;
        padding:1rem;
        color:black;
        border-radius:2px;
        border-bottom:2px solid black;

        &::placeholder{
          color:darken(white, 80%);
        }
        &:focus{
          outline:none;
        }
      }
    }

    .#{$ms}-item {
      opacity: 1;
      height:500px;
    }
    .#{$ms}-enter {
      opacity:0;
      height:0px;
    }
    .#{$ms}-enter-active {
      transition: all 1s ease;
    }
    .#{$ms}-enter-to {
      opacity: 1;
      height:500px
    }
    .#{$ms}-leave {
      opacity: 1;
      height:500px;
    }
    .#{$ms}-leave-active {
      transition: all 1s ease;
    }
    .#{$ms}-leave-to {
      opacity: 0;
      height:0px;
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      overflow: scroll;
      padding-top:3rem;
      margin-left:0;
      padding-left:0;
      // animation:grow 1s ease;
      
      .#{$ms}__element{
        list-style: none;
        text-align: left;
        @extend .__#{$ms}__EL;
        // height:2.5rem;
        // width:100%;
        padding:5px;
        margin:5px;
        font-size: 1.5rem;
        &:hover{
          cursor:pointer;
        }
      }
    }
  }

  .projects-list{
    display: flex;
    flex-wrap:wrap;
    justify-content: space-around;
    align-items: baseline;
    width:100%;
    margin: {
      left:2rem;
      right:2rem;
      top:4rem;
    }
    perspective: 20px;
    
    .project-item {
      width:30%;

      @include mobile {
        width:100%;
      }

      margin:1rem;
    }
  }



  @keyframes fadeInOut{
    from{
      opacity:1;
      transform:translateY(0px);
    }
    to{
      opacity:0.1;
      transform:translateY(-10px);
    }
  }

  button{
    all:unset;
  }
  .blurred{
    filter:blur(5px);
    transition:filter 1s ease-out;
  }

  .wild{
    $grad-color:rgba(black, 0.3);
    background-image:url(../assets/waterfall.jpg), linear-gradient(to right, $grad-color, $grad-color);
    background-blend-mode:soft-light;
    background-size: cover;
    background-attachment: fixed;
  }
  .sunset{
    // background-image:url(../assets/nightsky_sml.jpg), $sunset;
    background-blend-mode:soft-light;
    background-size: cover;
    background-attachment: fixed;
    @include mobile{

      // background-image: url(../assets/nightsky.jpg);
      background:$mobile_sunset;
      background-size: auto 200vh;
      background-repeat: repeat;
      // position: fixed;
      // height:100vh;
      // width:100vw;
    }
  }
  .flex-center-around{
    display: flex;
    justify-content: space-around;
    align-items:space-around;
  }
  .flex-around-center{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items:center;
  }

  .search-bg{
    background-color:$bg-main;
    padding-top:2rem;
    margin-top:-2rem;
    text-align: center;
    padding-bottom:2rem;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .projects-bg{
    // mix-blend-mode: screen;
    background-color:$bg-main;
    padding-top:2rem;
    margin-top:-2rem;
    // background-image:linear-gradient(to bottom, white, transparent, transparent);
  }
  .projects{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // padding-top:4rem;

    padding-bottom:4rem;
    .scroll-prompt{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:1.5rem;
      p{
      }
      i{
        font-size:1.3em;
      }
      // text-shadow: 0px -1px 10px rgba($colorE, 0.3);
      animation: fadeInOut 1100ms ease-in-out infinite alternate;
    }
  }



  .fade-enter-active, .fade-leave-active {
  transition: opacity 1s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
</style>


// WEBPACK FOOTER //
// Portfolio.vue?302b4630